<div class="account-detail-container">
    <div class="title-section">
        <span class="title">COMMUNICATION PREFERENCES</span>
    </div>
    <div class="details-section">
        <div class="list-item">
            <span class="icon">
                <mat-icon class="material-symbols-outlined">mark_email_unread</mat-icon>
            </span>
            <span class="detail" style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
                <div>
                    <p class="field-name">EMAIL NOTIFICATIONS</p>
                    <p class="field-value">Important messages will be sent to your inbox</p>
                </div>
                <div class="opt-out-arena-eq-toggle">
                  <mat-slide-toggle
                      [checked]="profileData?.activeCommunicationTypes?.includes('EMAIL')"
                      (change)="toggleHandler('EMAIL', $event)"
                    >
                  </mat-slide-toggle>
                </div>
            </span>
        </div>
        <div class="list-item">
            <span class="icon">
                <mat-icon class="material-symbols-outlined">notification_multiple</mat-icon>
            </span>
            <span class="detail" style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
                <div>
                    <p class="field-name">TEXT MESSAGES</p>
                    <p class="field-value">Important messages will be sent via text</p>
                </div>
                <div class="opt-out-arena-eq-toggle">
                  <mat-slide-toggle
                      [checked]="profileData?.activeCommunicationTypes?.includes('SMS')"
                      (change)="toggleHandler('SMS', $event)"
                    >
                  </mat-slide-toggle>
                </div>
            </span>
        </div>
    </div>
</div>
